
define('text!modules/reporting/campaigns/reachFrequency/templates/chart.html',[],function () { return '<div class="rf-canvas-container">\n  <div id="rf-chart"></div>\n  {{>chartNoDataChart}}\n</div>\n';});

